import React from 'react';
import PropTypes from 'prop-types';

// Basic structure for the new component using Flexbox for layout
// We'll refine styling as needed, potentially adding shared borders etc.
export const CBInputWithSelectAddon = ({
  value,
  onChange,
  placeholder,
  disabled,
  addonElement,
  className = '',
  inputClassName = '',
  addonClassName = '',
  ...rest // Pass any other standard input props
}) => {
  return (
    <div className={`flex items-stretch border border-gray-300 rounded-md focus-within:ring-1 focus-within:ring-blue-500 focus-within:border-blue-500 overflow-hidden ${className}`}>
      <input
        type="text"
        value={value || ''}
        onChange={(e) => onChange(e.target.value)} // Assuming onChange expects the value directly
        placeholder={placeholder}
        disabled={disabled}
        className={`flex-grow p-2 border-0 focus:ring-0 focus:outline-none ${inputClassName}`}
        {...rest}
      />
      {addonElement && (
        <div className={`flex items-center border-l border-gray-300 bg-gray-50 ${addonClassName}`}>
          {/* The addonElement (CBSelect) will be rendered here */}
          {addonElement}
        </div>
      )}
    </div>
  );
};

CBInputWithSelectAddon.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  addonElement: PropTypes.node.isRequired, // Expecting a React node (the CBSelect)
  className: PropTypes.string, // Optional class for the wrapper div
  inputClassName: PropTypes.string, // Optional class for the input element
  addonClassName: PropTypes.string, // Optional class for the addon wrapper div
};

export default CBInputWithSelectAddon;